<template>
  <section id="topbanner">
    <div id="index-banner" class="parallax-container">
        <div class="section no-pad-bot no-pad-margin">
          <div class="container no-pad-margin">
              <div class="row center top-banner" >
                <h1 class="header col s12 light-image center hide-on-small-only top-banner"> 
                  &bull; NodeJS &bull; NestJS  <br> 
                  &bull; JavaScript &bull; TypeScript <br> &bull; SQL  &bull; NoSQL
                </h1>
                <!-- Mobile -->
                <h4 class="header col s12 light-image center hide-on-med-and-up"> Back-end Developer </h4>
                <h4 class="header col s12 light-image center hide-on-med-and-up"> &bull; NodeJS &bull; NestJS</h4>
              </div>
              <br><br>
          </div>
        </div>
        <div class="parallax" id="slogan"><img src="../.././static/img/topo.jpg" alt="Software Developer"></div>
    </div>
    <h5 class="header center teal-text text-lighten hide-on-small-only">  
      <p class="center sdc-title"> Node Back-end Developer</p>
      <a href="https://wa.me/5511981671595"><i class="fa fa-whatsapp"></i></a> 
      <a href="tel:+5511981671595">{{ telefone }}</a>
      <p class="center"><a href="mailto:juscilan@gmail.com">juscilan@gmail.com</a></p>
    </h5> 
    <!-- Mobile -->
    <h5 class="header center teal-text text-lighten hide-on-med-and-up"> 
      <a href="https://wa.me/5511981671595"><i class="fa fa-whatsapp"></i></a> 
      <a href="tel:+5511981671595">{{ telefone }}</a>
      <br>
    </h5> 
    <h5 class="header center teal-text text-lighten ">  
      <div v-show="anglevisible">
        <a class="scrollSoft">
          <!-- <i id="angle-down" class="fa fa-angle-down black-text " style="font-size:48px" > </i> -->
        </a>
      </div>
    </h5>     
   </section>        
</template>

<script>

import { blink } from './common/jm-blink'
import { scrolltop } from './common/jm-scroll'

export default {
  name: 'top-component',
  data () {
    return {
      telefone: '+55 11 98167-1595',
      anglevisible: true
    }
  },
  mounted () {
    blink('angle-down')
    scrolltop(top => {
      if (top > 50) {
        this.$data.anglevisible = false
      } else {
        this.$data.anglevisible = true
      }
    })
  }
}

</script>

<style scoped>

  .sdc-title {
    font-size: 40px;
  }

  @media only screen and (max-width: 577px) {
    .no-pad-margin {
      margin-top: 75px;
    }    
  }

  @media only screen and (min-width:321px) and (max-width:768px){
    .no-pad-margin {
      margin-top: 75px;
    }      
  }

  @media only screen and (min-width: 769px) {
    .no-pad-margin {
      margin-top: 110px;
    }
    .no-pad-margin {
      margin-top: 50px
    }
 
  }

</style>



// WEBPACK FOOTER //
// jm-b-top-banner.vue?24596253